import Timeline from '../../chart/timeline';
import BaselineChart from '../../baselines/chart';
import TodayMarker from '../../chart/todayMarker';

/**
 * Root total-estimate can keep import/create dates far outside children.
 * dhtmlx then hides it via show_tasks_outside_timescale filter before
 * resetProjectDates runs on visible items — sync dates first.
 */
function syncRootProjectDates(instance) {
  const rootId = instance.config.root_id || 0;
  const rootTaskIds = instance.getChildren(rootId) || [];

  rootTaskIds.forEach(taskId => {
    if (!instance.isTaskExists(taskId)) return;

    const task = instance.getTask(taskId);
    if (task.type !== instance.config.types.project || !instance.hasChild(taskId)) return;

    const dates = instance.getSubtaskDates(taskId);
    if (!dates?.start_date || !dates?.end_date) return;

    const isOutsideChildrenRange = +task.start_date > +dates.end_date
      || +task.end_date < +dates.start_date;

    if (!isOutsideChildrenRange) return;

    task.start_date = new Date(dates.start_date);
    task.end_date = new Date(dates.end_date);
    task.duration = instance.calculateDuration(task);
  });
}

export default instance => {
  instance.attachEvent('onBeforeGanttRender', () => {
    syncRootProjectDates(instance);
    Timeline.updateTimeScaleRange();
    BaselineChart.onBeforeGanttRender();
  });
  instance.attachEvent('onBeforeGanttRender', () => setTimeout(() => {
    TodayMarker.onBeforeGanttRender();
  }));
};
